import { cn } from '@/lib/utils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot='skeleton'
      className={cn('bg-accent animate-pulse rounded-md', className)}
      aria-live='polite'
      aria-label='Loading'
      role='progressbar'
      aria-valuetext='Loading'
      {...props}
    />
  );
}

export { Skeleton };
